import {
  ProgramService,
  QuedroIntegrationService,
  TemplateService,
  PropertyDiscoveryService,
  OrderService,
  BillingService,
  AuthService,
  PropertyService,
  AgentService,
  EmailService,
  ConfigurationService,
  PropertyEventService,
  CampaignService,
  ReadLayer,
  StripeService,
  CustomerPortalService,
  MonitoringService,
  SellerService,
  MediaService,
  RealmediaCoreService,
  CustomerApiIntegrationService
} from "@adfenix/types";
import { CustomHttpClient } from "./HttpClient";

export * from "./configService";
export * from "./authService";
export * from "./stripeService";
export * from "./templateService";
export * from "./taxService";
export * from "./reportingService";
export * from "./propertyService";
export * from "./readLayerService";
export * from "./facebookService";
export * from "./billingService";
export * from "./campaignService";
export * from "./stripeService";
export * from "./customerPortalService";
export * from "./sellerService";

const client = new CustomHttpClient();

export const QuedroIntegrationServiceApi = Object.seal(
  new QuedroIntegrationService.Api(client)
);
export const ProgramServiceApi = Object.seal(new ProgramService.Api(client));
export const TemplateServiceApi = Object.seal(new TemplateService.Api(client));
export const PropertyDiscoveryServiceApi = Object.seal(
  new PropertyDiscoveryService.Api(client)
);
export const OrderServiceApi = Object.seal(new OrderService.Api(client));
export const BillingServiceApi = Object.seal(new BillingService.Api(client));
export const AuthServicesApi = Object.seal(new AuthService.Api(client));
export const PropertyServiceApi = Object.seal(new PropertyService.Api(client));
export const AgentServiceApi = Object.seal(new AgentService.Api(client));
export const EmailServiceApi = Object.seal(new EmailService.Api(client));
export const ConfigServiceApi = Object.seal(
  new ConfigurationService.Api(client)
);
export const PropertyEventServiceApi = Object.seal(
  new PropertyEventService.Api(client)
);
export const CampaignServiceApi = Object.seal(new CampaignService.Api(client));
export const CustomerPortalServiceApi = Object.seal(
  new CustomerPortalService.Api(client)
);
export const ReadLayerApi = Object.seal(new ReadLayer.Api(client));
export const StripeServiceApi = Object.seal(new StripeService.Api(client));
export const MonitoringServiceApi = Object.seal(
  new MonitoringService.Api(client)
);

export const SellerServiceApi = Object.seal(new SellerService.Api(client));

export const MediaServiceApi = Object.seal(new MediaService.Api(client));
export const RealmediaCoreServiceApi = Object.seal(
  new RealmediaCoreService.Api(client)
);

export const CustomerApiIntegrationServiceApi = Object.seal(
  new CustomerApiIntegrationService.Api(client)
);
